import React from 'react';
import { withRouter, RouteComponentProps } from 'react-router';
import { injectIntl, InjectedIntlProps } from 'react-intl';
import { compose, ExecutionResult } from 'react-apollo';
import GraphQLClient from '@api/graphql/GraphQLClient';
import * as Mutations from '@api/graphql/mutations';
import { PromotionPlace, createProductCategoryVariables, createProductCategory } from '@api/graphql/types';
import { Paths } from '..';
import Form from '@components/Form/Form';

type Props = {
} & InjectedIntlProps & RouteComponentProps;

interface State {
    formData: createProductCategoryVariables;
}

class PromotionCategoryCreate extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);

        this.state = {
            formData: {
                name: '',
                url_key: '',
                content: '',
                is_enable: true,
                date_from: null,
                date_to: null,
                show_in_menu: false,
                keywords: '',
                description: '',
                is_promotion: true,
                promotion_place: PromotionPlace.PROMO_1,
                is_homepage_prohibited: false,
            },
        };
    }

    public onSubmit = (variables: createProductCategoryVariables) => {
        return GraphQLClient.mutate({
            mutation: Mutations.createProductCategory, variables,
        });
    }
    private validate(): boolean {
        return true;
    }

    private onRedirectFunction = (response: ExecutionResult<createProductCategory>) => {
        const id = response.data && response.data.createProductCategory ? response.data.createProductCategory.id : undefined;
        if (id) {
            return `${Paths.promotionCategory}/${id}`;
        }
        return undefined;
    }

    public render() {
        const fields = [
            {name: 'name', type: 'text', props: {required: true}},
            {name: 'url_key', type: 'text', props: {required: true}},
            {name: 'content', type: 'markdown', props: {prefix: 'promotions'}},
            {name: 'date_from', type: 'date'},
            {name: 'date_to', type: 'date'},
            {name: 'keywords', type: 'text'},
            {name: 'description', type: 'text'},
            {name: 'is_enable', type: 'checkbox'},
            {name: 'promotion_place', type: 'promotioncategoryselect', props: {required: false, alias: ['promotion']}},
        ];

        return (
            <div className="row">
                <div className="col-lg-12">
                    <div className="ibox float-e-margins">
                        <div className="ibox-content">
                            <Form
                                fields={[{id: 'default', fields}]}
                                validate={this.validate}
                                intlPrefix={'module.promotionCategory'}
                                redirectPath={this.onRedirectFunction}
                                formData={this.state.formData}
                                onSubmit={this.onSubmit}
                            />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default compose(
    injectIntl,
    withRouter,
)(PromotionCategoryCreate);



// WEBPACK FOOTER //
// ./src/modules/PromotionCategory/pages/PromotionCategoryCreate.tsx